export function formatToDollarShort(number: number) {
  if (number >= 1_000_000) {
    const value = number / 1_000_000;
    const rounded = Math.round(value * 10) / 10; // Round to 1 decimal place
    return `$${rounded % 1 === 0 ? Math.floor(rounded) : rounded.toFixed(1)}M`;
  }

  if (number >= 1_000) {
    const value = number / 1_000;
    const rounded = Math.round(value * 10) / 10; // Round to 1 decimal place
    return `$${rounded % 1 === 0 ? Math.floor(rounded) : rounded.toFixed(1)}K`;
  }

  if (number === 0) return '$0';

  return `$${number}`;
}
